import { graphql } from 'react-relay';

export const getDrawingSetVersionListQuery = graphql`
    query getDrawingSetVersionListQuery($input: DrawingSetVersionListInput!, $first: Int) {
        ...drawingSetVersionListFragment @arguments(input: $input, first: $first)
    }
`;
